import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { DashboardCardContext } from "../context";

export function addCompletionByMaturityCards(ctx: DashboardCardContext) {
  const { view, language, settings } = ctx;

  const orderedMaturityEntries = (
    settings?.configuration?.maturityConfiguration ?? []
  )
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .filter((entry) => Boolean(entry.name));

  orderedMaturityEntries.forEach((maturityEntry, index) => {
    const maturityName = maturityEntry.name ?? "";
    const componentId = `completionByMaturity-${index}-${maturityName
      .toLowerCase()
      .replace(/\s+/g, "-")}`;

    const completionByMaturityCard = view.addComponent({
      component: PMDonutChartCard,
      layoutProps: {
        componentId,
        labels: ["donutChart", "chart", "completion", "maturity"],
        title:
          getLocalizedMessage(language, "cards.completionByMaturity.title", {
            maturityName,
          }) || `Completion of Maturity - ${maturityName}`,
        description:
          getLocalizedMessage(
            language,
            "cards.completionByMaturity.description",
            { maturityName }
          ) ||
          "Distribution of completion degrees for activities in this maturity",
      },
    });

    completionByMaturityCard.mapLayoutProps(({ language }) => ({
      componentId,
      labels: ["donutChart", "chart", "completion", "maturity"],
      title:
        getLocalizedMessage(language, "cards.completionByMaturity.title", {
          maturityName,
        }) || `Completion of Maturity - ${maturityName}`,
      description:
        getLocalizedMessage(
          language,
          "cards.completionByMaturity.description",
          {
            maturityName,
          }
        ) ||
        "Distribution of completion degrees for activities in this maturity",
    }));

    completionByMaturityCard.mapState(({ dashboard, settings, language }) => {
      const items =
        dashboard?.projects?.flatMap(
          (project) => project.reportingItems ?? []
        ) ?? [];

      const maturityItems = items.filter(
        (item) => (item.basicItem?.maturity ?? "") === maturityName
      );

      const completionDefinitions = (
        settings?.configuration?.degreeOfCompletionDefinition ?? []
      )
        .slice()
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

      const data = completionDefinitions.map((entry) => ({
        label: entry.name ?? "",
        value: maturityItems.filter(
          (item) => (item.degreeOfCompletion ?? "") === (entry.name ?? "")
        ).length,
        color: entry.color ?? "",
      }));

      return {
        title:
          getLocalizedMessage(language, "cards.completionByMaturity.title", {
            maturityName,
          }) || `Completion of Maturity - ${maturityName}`,
        description:
          getLocalizedMessage(
            language,
            "cards.completionByMaturity.description",
            { maturityName }
          ) ||
          "Distribution of completion degrees for activities in this maturity",
        icon: "DonutLarge",
        data,
      };
    });

    completionByMaturityCard.mapVisibility(({ settings }) => {
      return settings?.configuration?.useCase === "maturity";
    });
  });
}
